import { render, staticRenderFns } from "./Page-Reports.vue?vue&type=template&id=06956b32"
import script from "./Page-Reports.vue?vue&type=script&lang=js"
export * from "./Page-Reports.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports